import { Variants } from 'motion/react'
import { filterTiming } from '../TagFilter/filterAnimation'

// Every timing of the location filter's animation in seconds, it follows the theme filter's.
// The overlay fades in and the close button spins in, the map waits for its tiles, then fades in
// settling from a slight zoom, and the pins and cluster badges pop in rippling out from the centre of
// the map, each one's label fading in after it. On close the map and the close button fade out at
// once while the overlay fades away.
// The pins are a css animation: markercluster owns their elements, and Leaflet positions them with a
// transform
export const geographicFilterTiming = {
  overlay: filterTiming.overlay,
  open: {
    map: { duration: 0.6, ease: [0.2, 0, 0, 1] },
    mapStartScale: 1.03,
    // the map starts once the overlay has mostly faded in, then waits for its tiles, but never longer
    // than the max wait, so slow online tiles don't hold it back
    mapMinWait: 0.15,
    mapMaxWait: 0.6,
    // the theme buttons' overshoot, so the pins pop into place
    // the start scale is in the map-pin-in keyframes
    pin: { duration: 0.45, ease: [0.34, 1.56, 0.64, 1] },
    // after the map has started to fade in
    pinDelay: 0.15,
    // on top of the pin's delay: the corners of the map start this much later than its centre
    pinSpread: 0.6,
    // after its pin has started to pop in
    label: { delay: 0.25, duration: 0.3, ease: [0.2, 0, 0, 1] },
  },
  close: {
    map: filterTiming.close.button,
  },
} as const

export const overlayVariants: Variants = {
  hidden: { opacity: 0, transition: geographicFilterTiming.overlay },
  visible: { opacity: 1, transition: geographicFilterTiming.overlay },
}

export const mapVariants: Variants = {
  hidden: {
    opacity: 0,
    scale: geographicFilterTiming.open.mapStartScale,
    transition: geographicFilterTiming.close.map,
  },
  visible: { opacity: 1, scale: 1, transition: geographicFilterTiming.open.map },
}

const cubicBezier = (ease: readonly number[]) => `cubic-bezier(${ease.join(',')})`

// The css animations of a pin and of its label, the distance is the pin's from the centre of the map,
// 1 being a corner
export const getPinAnimations = (distance: number) => {
  const { pin, pinDelay, pinSpread, label } = geographicFilterTiming.open
  const delay = pinDelay + Math.min(distance, 1) * pinSpread
  const labelDelay = delay + label.delay

  return {
    pin: `map-pin-in ${pin.duration}s ${cubicBezier(pin.ease)} ${delay}s both`,
    label: `map-label-in ${label.duration}s ${cubicBezier(label.ease)} ${labelDelay}s both`,
  }
}

// from the start of the pins' animation until the last label has faded in
export const getPinCascadeDuration = () => {
  const { pin, pinDelay, pinSpread, label } = geographicFilterTiming.open
  return pinDelay + pinSpread + Math.max(pin.duration, label.delay + label.duration)
}
